import React from 'react';

import { queryGetInvoicePDF, queryResendInvoiceEmail } from '../../../Queries';

import NavigationBreadcrumbs from '../../Common/NavigationBreadcrumbs';
import { getBillingDashboardPageBreadcrumb } from '../Billing/BillingDashboardPage';
import { getInvoiceListPageBreadcrumb } from './InvoiceListPage';

import PageHeader from '../../Common/PageHeader';

import ActionButton from '../../Common/ActionButton';

import InvoicePanel from './InvoicePanel';

import { INVOICE_TYPE_ENUM } from '../../../Entities/Invoice';
import PageContent from '../PageContent';
import InvoicePanelConfig from './Config/InvoicePanelConfig';
import featureFlags from '../../../featureFlags';
import { getRedirectUrl } from '../../../Utils/envUrl';


class InvoiceDetailPage extends React.Component {
  state = {
    invoiceNewMode: false,
    invoiceDownloadingState: false,
    invoiceEmailSending: false
  };

  facilityId;
  invoiceId;


  constructor(props) {
    super(props);

    const urlSearchParams = new URLSearchParams(window.location.search);

    const facilityId = urlSearchParams.get('facility');
    this.facilityId = (facilityId !== null) ? facilityId : facilityId;

    this.invoiceId = urlSearchParams.get('invoice');

    this.state.invoiceNewMode = !this.invoiceId;
  }

  resendInvoiceEmail() {
    this.setState({ invoiceEmailSending: true }, async () => {
      try {
        await queryResendInvoiceEmail({ invoice_id: this.invoiceId });
      } catch (err) {
        if (err.text) {
          err.text().then(errorMessage => {
            alert('An error occurred while retrieving the invoice PDF:\n\n' + errorMessage);
          });
        }
        else {
          alert('An error occurred while retrieving the invoice PDF.');
        }
      }

      this.setState({ invoiceEmailSending: false })
    });

  }

  downloadInvoice() {
    if (this.invoiceId === null) return;

    this.setState({ invoiceDownloadingState: true }, () => {

      queryGetInvoicePDF({ invoice_id: this.invoiceId })
        .then(response => {
          if (!response.ok) throw response;
          return response.blob();
        })
        .then(blob => blob.text())
        .then(blobData => {
          const binary = atob(blobData.replace(/\s/g, ''));
          const length = binary.length;
          const buffer = new ArrayBuffer(length);
          const view = new Uint8Array(buffer);
          for (let i = 0; i < length; i++) {
            view[i] = binary.charCodeAt(i);
          }
          const pdfBlob = new Blob( [view], { type: 'application/pdf' } );

          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(pdfBlob, 'invoice.pdf');
          }
          else {
            let linkElement = document.createElement('a');
            let url = window.URL;
            let objectUrl;
            linkElement.type = 'application/pdf';
            linkElement.download = 'invoice.pdf';
            linkElement.href = objectUrl = url.createObjectURL(pdfBlob);
            linkElement.dispatchEvent(new MouseEvent('click'));
            setTimeout(url.revokeObjectURL(objectUrl));
          }

          this.setState({ invoiceDownloadingState: false });
        })
        .catch(error => {
          if (error.text) {
            error.text().then(errorMessage => {
              alert('An error occurred while retrieving the invoice PDF:\n\n' + errorMessage);
            });
          }
          else {
            alert('An error occurred while retrieving the invoice PDF.');
          }

          this.setState({ invoiceDownloadingState: false });
        });
    });
  }


  handleDownloadClick = () => {
    this.downloadInvoice();
  }

  handleResendEmailClick = () => {
    this.resendInvoiceEmail();
  }

  renderNavigationBreadcrumbs() {
    const breadcrumbs = [];
    breadcrumbs.push(getBillingDashboardPageBreadcrumb(false, this.facilityId));
    breadcrumbs.push(getInvoiceListPageBreadcrumb(false, this.facilityId));
    breadcrumbs.push(getInvoiceDetailPageBreadcrumb());

    if(featureFlags.FEATURE_UNIVERSAL_SEARCH){
      breadcrumbs.push({ title: 'Universal Search', href: getRedirectUrl(window.origin) })
    }

    return (
      <NavigationBreadcrumbs breadcrumbs={breadcrumbs} />
    );
  }


  renderPageHeader() {
    const {
      invoiceDownloadingState,
      invoiceEmailSending
    } = this.state;

    const heading = 'Invoice Detail';
    const actions = [];
    if (this.invoiceId !== null) {
      actions.push(
        <ActionButton label="Download PDF"
          inProgressState={invoiceDownloadingState}
          onClick={this.handleDownloadClick}
        />,
        <ActionButton
          label="Resend Invoice"
          inProgressState={invoiceEmailSending}
          onClick={this.handleResendEmailClick}
        />
      );
    }

    return (
      <PageHeader heading={heading}
        actions={actions}
      />
    );
  }

  renderInvoice(config) {
    const {
      invoiceNewMode
    } = this.state;
    return (
      <InvoicePanel
        newMode={invoiceNewMode}
        config={config}
      />
    );
  }


  render() {
    const {
      invoiceNewMode
    } = this.state;

    return (
      <div className="parkchirp--page parkchirp--page--invoice-detail">
        {this.renderNavigationBreadcrumbs()}
        {this.renderPageHeader()}
        <div className="parkchirp--page-content">
          <div className="parkchirp--page--invoice-detail--main-content-container">
            <PageContent
              errorMessage="The following errors occurred while retrieving the invoice:"
              loadingMessage="Retrieving invoice, please wait..."
              className={`parkchirp--invoice-panel${(invoiceNewMode) ? ' parkchirp--invoice-panel--new' : ''} `}
              config={new InvoicePanelConfig({
                newMode: invoiceNewMode,
                invoiceId: this.invoiceId,
                facilityId: this.facilityId,
                newInvoiceType: INVOICE_TYPE_ENUM.MANUAL_INVOICE
              })}
              renderContent={config => this.renderInvoice(config)}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default InvoiceDetailPage;


export function getInvoiceDetailPageBreadcrumb(currentPage = true, invoiceId = null, facilityId = null) {
  const title = 'Invoice';
  const href = (currentPage) ? null :
    `?page=parkchirp_invoice${(invoiceId !== null) ? `&invoice=${invoiceId}` : ''}${(facilityId !== null) ? `&facility=${facilityId}` : ''}`;

  return { title, href };
}
